/* =============================================================================
   pl-v6.js — sexta ronda: escaneo de síntomas, cubo de beneficios, moneda
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.scenes = ONX.scenes || {};

  // Causa raíz: una línea de escaneo baja por los síntomas y cada uno se enciende
  // (color + check + pulso) cuando la línea lo alcanza. Luego las líneas bajan a la raíz.
  ONX.scenes['pl-causa'] = function (el, gsap, ST) {
    var wrap = el.querySelector('.pca__scan-wrap'), scan = el.querySelector('.pca__scan');
    var cards = Array.prototype.slice.call(el.querySelectorAll('.pca__card'));
    gsap.from(cards, { y: 40, opacity: 0, stagger: 0.08, duration: 0.7, ease: 'power3.out', scrollTrigger: { trigger: wrap, start: 'top 85%' } });
    if (wrap && scan) {
      ST.create({
        trigger: wrap, start: 'top 62%', end: 'bottom 52%', scrub: true,
        onUpdate: function (s) {
          var h = wrap.offsetHeight, y = s.progress * h;
          scan.style.transform = 'translateY(' + y.toFixed(1) + 'px)';
          scan.style.opacity = s.progress > 0.01 && s.progress < 0.99 ? 1 : 0;
          cards.forEach(function (c) { c.classList.toggle('is-lit', c.offsetTop + c.offsetHeight * 0.5 < y); });
        }
      });
    }
    var root = el.querySelector('[data-pca-root]'); if (!root) return;
    var foto = root.querySelector('[data-pca-foto]');
    if (foto) {
      // la foto se abre en círculo desde la raíz y se acomoda; luego entra el texto
      var tf = gsap.timeline({ scrollTrigger: { trigger: foto, start: 'top 88%', end: 'top 35%', scrub: 0.6 } });
      tf.fromTo(foto, { clipPath: 'circle(14% at 50% 58%)' }, { clipPath: 'circle(75% at 50% 58%)', ease: 'none', duration: 1 }, 0)
        .fromTo(foto.querySelector('img'), { scale: 1.25 }, { scale: 1, ease: 'none', duration: 1 }, 0)
        .from(root.querySelector('.pca__causa'), { y: 30, opacity: 0, duration: 0.4 }, 0.6);
      return;
    }
    if (!root.querySelector('.pca__line')) { // pcr: lo anima anime.js (pl-v10.js)
      gsap.from(root.querySelector('.pca__causa'), { y: 30, opacity: 0, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: root, start: 'top 80%' } });
      return;
    }
    var lines = root.querySelectorAll('.pca__line');
    lines.forEach(function (l) { var L = l.getTotalLength(); l.style.strokeDasharray = L; l.style.strokeDashoffset = L; });
    var tl = gsap.timeline({ scrollTrigger: { trigger: root, start: 'top 85%', end: 'top 30%', scrub: 0.6 } });
    tl.to(lines, { strokeDashoffset: 0, opacity: 1, stagger: 0.05, ease: 'none', duration: 0.6 }, 0)
      .from(root.querySelector('.pca__bulb'), { scale: 0, transformOrigin: '50% 50%', duration: 0.2, ease: 'back.out(3)' }, 0.55)
      .to(root.querySelector('.pca__glow'), { opacity: 0.8, duration: 0.2 }, 0.6)
      .from(root.querySelector('.pca__causa'), { y: 30, opacity: 0, duration: 0.25 }, 0.65);
    gsap.to(root.querySelector('.pca__glow'), { scale: 1.35, transformOrigin: '50% 50%', opacity: 0.35, duration: 1.4, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1 });
  };

  // Beneficios: la foto gira como la cara de un cubo y la tarjeta cambia de texto.
  ONX.scenes['pl-cubo'] = function (el, gsap) {
    var faces = el.querySelectorAll('.pcu__face'), steps = el.querySelectorAll('.pcu__step'), dots = el.querySelectorAll('.pcu__dots i');
    var card = el.querySelector('.pcu__card'), n = steps.length; if (!n) return;
    gsap.set(faces, { opacity: 0, rotateY: 90, transformOrigin: '100% 50%' }); gsap.set(faces[0], { opacity: 1, rotateY: 0 });
    gsap.set(steps, { autoAlpha: 0, y: 16 }); gsap.set(steps[0], { autoAlpha: 1, y: 0 });
    var act = -1;
    function mark(k) { if (k === act) return; act = k; dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); }); }
    mark(0);
    var tl = gsap.timeline({ defaults: { ease: 'power2.inOut' },
      scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.8,
        onUpdate: function (s) { mark(Math.min(n - 1, Math.floor(s.progress * n * 0.9999))); } } });
    for (var i = 1; i < n; i++) {
      var t = i - 0.4;
      tl.to(faces[i - 1], { rotateY: -90, transformOrigin: '0% 50%', duration: 0.32, ease: 'power2.in' }, t)
        .set(faces[i - 1], { opacity: 0 }, t + 0.32)
        .set(faces[i], { opacity: 1 }, t + 0.16)
        .fromTo(faces[i], { rotateY: 90, transformOrigin: '100% 50%' }, { rotateY: 0, duration: 0.32, ease: 'power2.out' }, t + 0.16)
        .to(steps[i - 1], { autoAlpha: 0, y: -12, duration: 0.14 }, t)
        .to(card, { scale: 0.96, duration: 0.12 }, t + 0.1)
        .to(card, { scale: 1, duration: 0.18, ease: 'back.out(2)' }, t + 0.22)
        .to(steps[i], { autoAlpha: 1, y: 0, duration: 0.18 }, t + 0.24);
    }
    tl.to({}, { duration: 0.25 });
  };

  // Garantía: la moneda cae girando y rebota; con el scroll se inclina un poco.
  ONX.scenes['pl-moneda'] = function (el, gsap) {
    var spin = el.querySelector('.pcoin__spin'); if (!spin) return;
    gsap.fromTo(spin, { y: -180, rotateX: 70, scale: 0.6, opacity: 0 },
      { y: 0, rotateX: 0, scale: 1, opacity: 1, duration: 1.3, ease: 'bounce.out', scrollTrigger: { trigger: el, start: 'top 75%' } });
    gsap.fromTo(el.querySelector('.pcoin'), { rotateX: 18 }, { rotateX: -18, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 0.6 } });
  };
})();
